import { createReducer } from '@reduxjs/toolkit';
import { getDocumentExpirationDaysEndpoint } from 'pages/dashboard/dashboard.config';
import { verifyContactsEndpoint } from 'pages/profile/profile.config';
import { apiRequestSuccess } from 'services/api/api.actions';
import {
  getPinProfileEndpoint,
  getUserBalanceEndpoint,
  getUserProfileEndpoint,
} from './user.config';
import {
  CertifiedContacts,
  GetExpirationDays,
  UserBalance,
  UserDataPayload,
  UserProfile,
} from './user.types';

const initialValues = {
  lastAccessDate: '' as string,
  profile: {} as UserProfile,
  balance: {
    realCashBalance: 0,
    withdrawableCashBalance: 0,
    bonusTypeBalances: [],
  } as UserBalance,
  pinCode: '' as string,
  documentExpiration: {} as GetExpirationDays,
  certifiedContacts: {} as CertifiedContacts,
};

const userReducer = createReducer(initialValues, (builder) =>
  builder.addCase(apiRequestSuccess, (state, action) => {
    const { payload } = action;
    if (payload.resourceId === getUserProfileEndpoint) {
      const data = payload.response.data as UserDataPayload;

      state.profile = data.personalData;
      state.lastAccessDate = data.lastAccessDate;

      return;
    }

    if (payload.resourceId === getUserBalanceEndpoint) {
      const balance: UserBalance | undefined =
        payload.response.data?.responseObject;

      if (balance) {
        state.balance = {
          realCashBalance: balance.realCashBalance,
          withdrawableCashBalance: balance.withdrawableCashBalance,
          bonusTypeBalances: balance.bonusTypeBalances ?? [],
        };
      }
      return;
    }

    if (payload.resourceId === getPinProfileEndpoint) {
      const pin = payload.response.data.pinCode as string;
      state.pinCode = pin;
      return;
    }

    if (payload.resourceId === getDocumentExpirationDaysEndpoint) {
      const { expirationDays, expirationDate } = payload.response.data;
      state.documentExpiration = { expirationDays, expirationDate };
      return;
    }

    if (payload.resourceId === verifyContactsEndpoint) {
      const isPhoneNumberCertified =
        payload.response.data.infoConto.filter(
          (e: any) => e.nome === 'OPTIN_CELLULARE' && e.valore === '1',
        ).length !== 0;

      const isEmailCertified =
        payload.response.data.infoConto.filter(
          (e: any) => e.nome === 'OPTIN_EMAIL' && e.valore === '1',
        ).length !== 0;

      state.certifiedContacts = {
        isPhoneCertified: isPhoneNumberCertified,
        isEmailCertified: isEmailCertified,
      };
      return;
    }
  }),
);

export default userReducer;
